<template>
  <div>
  </div>
</template>

<script>
import settings from "@/backend/LocalSettings";

export default {
  name: "base-widget",
  components: { 
  },
  data () {
    return { 
      loadingVisible: false
    }
  },
  methods: {
    async post(url, args={})
    {
      this.loadingVisible      = true;
      var             response = await this.$http.post(url, args );
      this.loadingVisible      = false;
      if( settings.verify_response(response, this.$rights)) 
      {
        return response.body;
      } else {
        this.$router.push("/");
      }
    },
  }
};
</script>

<style scoped>
 
</style>